<template>
        <div class="main-background">
            <!-- Titre de la page -->
            <v-row justify="center">
                <v-col cols="12" md="8">
                    <v-card class="ma-4">
                        <v-card-title class="headline">Conditions Générales d'Utilisation</v-card-title>
                        <v-card-text>
                            <h3>1. Introduction</h3>
                            <p>
                                Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et
                                l'utilisation du site frigofix.ch. En accédant à ce site, vous acceptez de respecter et
                                d'être lié par ces conditions. Si vous n'acceptez pas ces conditions, vous ne devez pas
                                utiliser ce site.
                            </p>
                            <h3>2. Utilisation de l'Application</h3>
                            <p>
                                Vous pouvez utiliser le site frigofix.ch uniquement à des fins personnelles et non
                                commerciales.
                            </p>
                            <p>
                                L'utilisation du site implique l'enregistrement de vos informations personnelles, telles
                                que votre adresse e-mail et votre mot de passe.
                            </p>
                            <p>Vous acceptez de fournir des informations exactes et de maintenir leur mise à jour.</p>

                            <h3>Gestion des Comptes</h3>
                            <p>Vous êtes responsable de la confidentialité de vos informations de compte, y compris
                                votre e-mail et votre mot de passe.</p>
                            <p>Vous vous interdisez de vendre, transférer ou partager votre compte avec des tiers. Toute
                                tentative de vente ou de transfert de compte entraînera la suspension immédiate de
                                l'accès à votre compte.</p>

                            <h3> Utilisation Abusive et Non Conforme</h3>
                            <p>Vous vous engagez à utiliser votre compte de manière respectueuse et conforme aux lois en
                                vigueur. L'utilisation abusive du site, y compris, mais sans se limiter à :</p>
                            <li>La manipulation, le piratage, ou la tentative de piratage du site ou de ses services ;
                            </li>
                            <li>L'utilisation de méthodes automatisées pour interagir avec le site (par exemple, des
                                bots, des crawlers, des scrapers) ;</li>
                            <li>L'envoi de spam ou d'autres contenus non sollicités ;</li>
                            <li>Toute activité frauduleuse ou malveillante, y compris l'usurpation d'identité ;</li>

                            <p>En cas de non-respect de ces règles, nous nous réservons le droit de suspendre ou de
                                supprimer votre compte sans préavis, sans que cela ne donne droit à compensation. Toute
                                activité susceptible de nuire à l'intégrité du site ou de perturber son bon
                                fonctionnement pourra également entraîner des actions légales.</p>


                            <h3>5. Inactivité et Désactivation de Compte</h3>
                            <p>
                                Si votre compte reste inactif pendant une période prolongée (par exemple, plus de 12
                                mois), nous nous réservons le droit de désactiver ou de supprimer votre compte. Cette
                                mesure est mise en place pour garantir une gestion efficace des comptes et la sécurité
                                des données.
                            </p>
                            <p>
                                En cas de suppression d'un compte pour inactivité, vous serez informé par e-mail à
                                l'adresse associée à votre compte. Vous aurez alors un délai raisonnable pour réactiver
                                votre compte ou pour prendre les mesures nécessaires avant la suppression définitive des
                                données associées.
                            </p>

                            <h3>6. Usage du Compte</h3>
                            <p>
                                Vous êtes seul responsable de l'usage qui est fait de votre compte, y compris toute
                                activité réalisée sous votre identifiant et mot de passe. Si vous pensez que votre
                                compte a été compromis ou utilisé de manière non autorisée, vous devez immédiatement en
                                informer frigofix.ch et changer votre mot de passe.
                            </p>
                            <p>
                                Il vous est interdit d'utiliser le compte d'une autre personne sans autorisation
                                explicite. Toute violation de cette règle peut entraîner la suspension ou la suppression
                                immédiate de votre compte.
                            </p>

                            <h3>7. Stockage des Données</h3>
                            <p>
                                frigofix.ch collecte et stocke des informations relatives à votre stock d'utilisateur,
                                mais ne collecte pas d'informations concernant les produits scannés par la caméra.
                            </p>
                            <p>
                                Les données relatives aux stocks sont stockées dans une base de données sécurisée et
                                sont utilisées uniquement pour la gestion de votre stock personnel.
                            </p>
                            <p>
                                Conformément au RGPD, vous avez le droit d'accéder à vos données, de les rectifier ou de
                                les supprimer à tout moment.
                            </p>
                            <p>
                                Les données sont hébergées en Allemagne et gérées via un système FusionAuth self-hosted
                                pour la gestion des utilisateurs.
                            </p>
                            <p>
                                <strong>Transfert en Suisse :</strong> Les données personnelles collectées peuvent être
                                transférées et stockées en Suisse à tout moment, en conformité avec les réglementations
                                applicables. La Suisse offre un niveau de protection des données similaire à celui de
                                l'Union Européenne.
                            </p>

                            <h3>8. Sécurité</h3>
                            <p>
                                Nous mettons en place des mesures de sécurité pour protéger vos informations
                                personnelles. Cependant, aucune méthode de transmission sur Internet ou de stockage
                                électronique n'est entièrement sûre. Nous ne pouvons garantir la sécurité absolue de vos
                                données.
                            </p>

                            <h3>9. Interdiction de Vendre le Compte</h3>
                            <p>
                                Vous vous engagez à ne pas vendre, échanger, ou transférer votre compte à des tiers.
                                Toute tentative de vendre ou de transférer un compte entraînera la résiliation de votre
                                accès sans préavis.
                            </p>

                            <h3>10. Responsabilité</h3>
                            <p>
                                frigofix.ch décline toute responsabilité en cas de dommages directs ou indirects liés à
                                l'utilisation du site.
                            </p>
                            <v-divider></v-divider>

                            <!-- Politique de Confidentialité -->
                            <h3>Politique de Confidentialité</h3>
                            <p>
                                Nous collectons des informations personnelles telles que votre e-mail et mot de passe
                                pour créer et gérer votre compte. Nous collectons également des informations liées à
                                votre stock d'utilisateur, mais nous ne collectons pas de données relatives aux produits
                                scannés via la caméra.
                            </p>
                            <h3>2. Utilisation des Données</h3>
                            <p>
                                Les informations que nous collectons sont utilisées pour :
                            </p>
                                <li>Gérer et sécuriser votre compte utilisateur.</li>
                                <li>Suivre et gérer les stocks associés à votre compte.</li>
                                <li>Améliorer l'expérience utilisateur sur frigofix.ch.</li>

                            <h3>3. Sécurité des Données</h3>
                            <p>
                                Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour
                                protéger vos données personnelles contre toute perte, mauvaise utilisation, ou accès non
                                autorisé.
                            </p>

                            <h3>4. Partage des Informations</h3>
                            <p>
                                Nous ne partageons pas vos informations personnelles avec des tiers, sauf si la loi
                                l'exige. Nous pouvons également partager des informations avec nos partenaires
                                sous-traitants, mais uniquement dans le cadre de la gestion des services associés à
                                frigofix.ch.
                            </p>

                            <h3>5. Droit d'accès, de Rectification et de Suppression</h3>
                            <p>
                                Conformément au RGPD, vous avez le droit de :
                            </p>
                                <li>Accéder à vos données personnelles.</li>
                                <li>Demander la rectification de vos données.</li>
                                <li>Demander la suppression de vos données dans la mesure où elles ne sont plus
                                    nécessaires à l'exécution des services ou à la conformité à une obligation légale.
                                </li>
                            <p>
                                Pour exercer ces droits, veuillez nous contacter à l'adresse suivante : <a
                                    href="mailto:service@frigofix.ch">service@frigofix.ch</a>.
                            </p>

                            <h3>6. Conservation des Données</h3>
                            <p>
                                Nous conservons vos informations personnelles aussi longtemps que nécessaire pour les
                                finalités mentionnées ci-dessus, ou aussi longtemps que la loi l'exige. Vous pouvez
                                demander la suppression de vos données à tout moment.
                            </p>

                            <h3>7. Transfert International des Données</h3>
                            <p>
                                Les données personnelles que nous collectons peuvent être transférées et stockées dans
                                un pays en dehors de l'Union Européenne, y compris en Suisse. Nous nous engageons à
                                assurer que ces données soient protégées par des mesures de sécurité appropriées
                                conformément au RGPD.
                            </p>
                            <v-divider></v-divider>

                            <!-- Informations sur le cookie -->
                            <h3>Politique de Cookies</h3>
                            <p>
                                Ce site utilise des cookies pour vous offrir une meilleure expérience utilisateur. Un
                                cookie est un petit fichier stocké sur votre appareil, utilisé pour identifier votre
                                session lors de l'accès à frigofix.ch.
                            </p>
                            <p>
                                Le seul cookie utilisé est celui nécessaire pour le stockage de votre token
                                d'authentification afin de maintenir votre session active pendant votre navigation sur
                                le site.
                            </p>

                            <h3>2. Type de Cookie Utilisé</h3>
                            <p>
                                <strong>Cookie d'authentification (token) :</strong> Ce cookie est utilisé pour
                                maintenir votre session active lorsque vous vous connectez à votre compte. Il est
                                essentiel pour l'authentification et la gestion de votre compte.
                            </p>
                            <p>
                                <strong>Durée de vie :</strong> La durée de vie du cookie correspond à la durée de votre
                                session. Il sera supprimé lorsque vous vous déconnectez ou lorsque la session expire.
                            </p>

                            <h3>3. Consentement</h3>
                            <p>
                                En utilisant ce site, vous consentez à l'utilisation de ce cookie conformément à cette
                                politique de cookies. Vous pouvez modifier vos préférences en matière de cookies à tout
                                moment via les paramètres de votre navigateur.
                            </p>

                            <h3>4. Gestion des Cookies</h3>
                            <p>
                                Vous avez la possibilité de refuser l'utilisation de ce cookie en désactivant les
                                cookies dans les paramètres de votre navigateur. Toutefois, notez que certaines
                                fonctionnalités du site, notamment l'authentification de votre compte, peuvent ne pas
                                fonctionner correctement si vous désactivez les cookies.
                            </p>

                            <h3>5. Droits liés aux Cookies</h3>
                            <p>
                                Conformément au RGPD, vous avez le droit de retirer votre consentement à tout moment.
                                Pour cela, il vous suffit de supprimer les cookies via les paramètres de votre
                                navigateur.
                            </p>
                        </v-card-text>
                        <v-card-actions><v-btn href="javascript:history.back()">Retour</v-btn></v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </div>
</template>